import { setIsFocusedInboxCapableService } from 'owa-mail-focused-inbox-config/lib/services/setIsFocusedCapableService';
import { getFolderIdForSelectedNode } from 'owa-mail-folder-forest-store';
import { createMailFolderTableQuery } from 'owa-mail-list-actions';
import updateAlwaysInCacheTableIds from 'owa-mail-list-actions/lib/actions/helpers/tableCache/updateAlwaysInCacheTableIds';
import { getListViewTypeForFolder } from 'owa-mail-list-store';
import { loadTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import { getUserConfiguration } from 'owa-session-store';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { action } from 'satcheljs/lib/legacy';

/**
 * Set Focused inbox On/Off
 * @param isFocusedInboxEnabled - Switch flag to indicate if Focused Inbox should be switched On/Off
 * @param skipServiceRequest - Whether to skip the service request to save the setting. Used when called as part of Options stitch
 */
export default action('setFocusedInboxOnOff')(function setFocusedInboxOnOff(
    isFocusedInboxEnabled: boolean,
    skipServiceRequest?: boolean
) {
    const folderIdForSelectedNode = getFolderIdForSelectedNode();

    // Reload selected folder only if it is Inbox
    if (folderIdToName(folderIdForSelectedNode) === 'inbox') {
        const tableQuery = createMailFolderTableQuery(
            folderIdForSelectedNode,
            getListViewTypeForFolder(folderIdForSelectedNode),
            'mail',
            isFocusedInboxEnabled ? FocusedViewFilter.Focused : FocusedViewFilter.None,
            'All'
        );

        loadTableViewFromTableQuery(tableQuery);
    }

    if (!skipServiceRequest) {
        // update userOptions property and save the setting
        getUserConfiguration().UserOptions.IsFocusedInboxEnabled = isFocusedInboxEnabled;

        updateUserConfiguration('OWA.UserOptions', [
            userConfigurationDictionaryEntry({
                DictionaryKey: userConfigurationDictionaryObject({
                    Type: 'String',
                    Value: ['IsFocusedInboxEnabled'],
                }),
                DictionaryValue: userConfigurationDictionaryObject({
                    Type: 'Boolean',
                    Value: [String(isFocusedInboxEnabled)],
                }),
            }),
        ]);

        // Make a request to set IsFocusedInboxCapable if IsFocusedInboxEnabled is set to true
        if (isFocusedInboxEnabled) {
            setIsFocusedInboxCapableService();
        }
    }

    updateAlwaysInCacheTableIds();
});
